import { useState, useEffect } from "react";
import { useNotificationSnackbar } from "../../../hooks/useNotificationSnackbar";
import { useTPClientService } from "../../../service/tpclient";
import { IOptionTree } from "../../../service/tpclient/interfaces/IOptionTree";

export const useOptionTreeParameters = (
  idTree: any,
  parameters: any
): [IOptionTree | null, boolean, () => void] => {
  const { getOptionTreeParameters } = useTPClientService();
  const [rows, setRows] = useState<IOptionTree | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { onErrorSnackbar } = useNotificationSnackbar();

  const fetch = async () => {
    try {
      if (idTree && parameters) {
        setLoading(true);
        const response = await getOptionTreeParameters(idTree, parameters);
        if (response.status === 200) {
          setRows(response.data);
          setLoading(false);
        } else {
          onErrorSnackbar(response.data);
          setLoading(false);
        }
      }
    } catch (error: any) {
      setRows(null);
      onErrorSnackbar(error);
      setLoading(false);
    }
  };

  const requestUpdate = () => {
    fetch();
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idTree, parameters]);

  return [rows, loading, requestUpdate];
};
